import AccountInfoTab from './AccountInfoTab';

export default AccountInfoTab;